module.exports = __webpack_public_path__ + "img/howto_ico06.d7b358b1.png";